import keyBy from 'lodash/keyBy'
import maxBy from 'lodash/maxBy'
import get from 'lodash/get'

const BASE_EDITION = 'Edición crítica'

function setPage(s, {side, pageNumber}) {
  if (s[side].editionName !== BASE_EDITION) {
    const page = s.document.editions
        .find(e => e.name === s[side].editionName).pages
        .find(p => p.number === pageNumber)
    if (page) {
      s[side].pageNumber = page.number
      s[side].start = page.start_verse
      s[side].end = page.end_verse
    }
  }
}

function align(s, target) {
  const source = target === 'left' ? 'right' : 'left'
  if (s[target].editionName === BASE_EDITION) {
    s[target].start = s[source].start
    s[target].end = s[source].end
  } else {
    const edition = s.document.editions.find(e => e.name === s[target].editionName)
    const bestPage = maxBy(edition.pages, p => {
      if (p.start_verse > s[source].end || s[source].start > p.end_verse) {
        return 0 // No intersection
      } else {
        const startIntersection = Math.max(s[source].start, p.start_verse)
        const endIntersection = Math.min(s[source].end, p.end_verse)
        return endIntersection - startIntersection
      }
    })
    s[target].pageNumber = bestPage.number
    s[target].start = bestPage.start_verse
    s[target].end = bestPage.end_verse
  }
}

export default {
  state: {
    documents: gon.documents,
    status: null,
    document: null,
    notes: null,
    bibliography: null,
    left: {
      editionName: BASE_EDITION,
      start: 1,
      end: 30,
      pageSize: 30,
      pageNumber: 1
    },
    right: {
      editionName: BASE_EDITION,
      start: 1,
      end: 30,
      pageSize: 30,
      pageNumber: 1
    }
  },
  mutations: {
    reset(s) {
      s.status = null
      s.document = null
      s.notes = null
      s.bibliography = null
    },
    setPending(s) {
      s.status = 'pending'
    },
    setError(s) {
      s.status = 'error'
    },
    setDocument(s, {document, start}) {
      s.status = 'done'
      s.document = document
      s.bibliography = keyBy(document.base.bibliography, 'id')
      s.notes = {...keyBy(document.base.notes, 'id'), ...s.bibliography}
      s.right.editionName = get(s.document.editions, '0.name', BASE_EDITION)
      setPage(s, {side: 'right', pageNumber: 1})
      s.left.editionName = BASE_EDITION
      if (start) {
        s.left.start = start
        s.left.end = start + s.left.pageSize
        align(s, 'right')
      } else {
        align(s, 'left')
      }
    },
    setEditionName(s, {side, name}) {
      s[side].editionName = name
      setPage(s, {side, pageNumber: 1})
      align(s, side)
    },
    setPageSize(s, {side, pageSize}) {
      s[side].pageSize = pageSize
      s[side].end = Math.min(s[side].start + pageSize - 1, s.document.base.verse_index.end)
    },
    setVerse(s, {side, start}) {
      if (s[side].editionName === BASE_EDITION) {
        const lastVerse = s.document.base.verse_index.end
        if (start + s[side].pageSize < lastVerse) {
          s[side].start = start + s[side].pageSize
          s[side].end = Math.min(s[side].start + s[side].pageSize - 1, lastVerse)
        } else {
          // Handle overflow
          s[side].start = lastVerse - s[side].pageSize
          s[side].end = lastVerse
        }
      }
    },
    nextVerses(s, side) {
      if (s[side].editionName === BASE_EDITION) {
        const lastVerse = s.document.base.verse_index.end
        if (s[side].start + s[side].pageSize < lastVerse) {
          s[side].start = s[side].start + s[side].pageSize
          s[side].end = Math.min(s[side].start + s[side].pageSize - 1, lastVerse)
        } else {
          // Handle overflow
          s[side].start = lastVerse - s[side].pageSize
          s[side].end = lastVerse
        }
      }
    },
    previousVerses(s, side) {
      if (s[side].editionName === BASE_EDITION) {
        if (s[side].start - s[side].pageSize > 1) {
          s[side].start = s[side].start - s[side].pageSize
          s[side].end = s[side].start + s[side].pageSize - 1
        } else {
          // Handle underflow
          s[side].start = 1
          s[side].end = s[side].pageSize
        }
      }
    },
    setPage,
    align
  },
  getters: {
    editionNames(s) {
      const options = s.document.editions.map(e => ({text: `${e.identifier}: ${e.name}`, value: e.name}))
      return [{text: BASE_EDITION, value: BASE_EDITION}, ...options]
    }
  },
  actions: {
    selectDocument({state, dispatch, commit, getters}, {code, start}) {
      if (code) {
        commit('setPending')
        const params = {
          method: 'GET',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          }
        }
        fetch(`./editions?document=${code}`, params)
            .then(r => r.status === 200 ? r.json() : Promise.reject(r.status))
            .then(r => commit('setDocument', {document: r, start}))
            .catch(_ => commit('setError'))
      } else {
        commit('reset')
      }
    }
  }
}